/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgDataWorkflow = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M12 8v3H6V7.8C7.2 7.4 8 6.3 8 5c0-1.7-1.3-3-3-3S2 3.3 2 5c0 1.3.8 2.4 2 2.8v8.3c-1.2.4-2 1.5-2 2.8 0 1.7 1.3 3 3 3s3-1.3 3-3c0-1.3-.8-2.4-2-2.8V13h6v3h10V8zM5 20c-.6 0-1-.4-1-1s.4-1 1-1 1 .4 1 1-.4 1-1 1zM5 6c-.6 0-1-.4-1-1s.4-1 1-1 1 .4 1 1-.4 1-1 1zm15 8h-6v-4h6z"
      fill="currentcolor"
    />
  </Icon>
);
export { SvgDataWorkflow as DataWorkflow };
